// extracted by mini-css-extract-plugin
module.exports = {"s10vj4cy":"s10vj4cy","sparkleAnimation-s10vj4cy":"sparkleAnimation-s10vj4cy","wchvb39":"wchvb39"};